import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import SectionTitle from "../../elements/sectionTitle/SectionTitle";
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import ConsultationTopics from '../../components/consultation/ConsultationTopics';
import ConsultationPricing from '../../components/consultation/ConsultationPricing';
import ConsultationAccordion from '../../elements/accordion/ConsultationAccordion';
import Separator from '../../elements/separator/Separator';
import Consultant from '../../elements/team/Consultant';
import ConsultationVideo from '../../elements/video/ConsultationVideo';
import RegistrationForm from '../../components/form/RegistrationForm';



const Registration = () => {
    return (
        <>
            <SEO title="Registration" />
            <main className="page-wrapper">
                <HeaderTopBar />
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                {/* This is the Service Categories Area */}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <RegistrationForm />
                    </div>
                </div>




    





                <FooterOne />
                <Copyright />
            </main>

        </>
    )
}

export default Registration
